$(document).ready(function(){

// Hide all divs with the class "content" initially
// $('.content').hide();

    /*========== start collection page mobile filter accordion js =====*/
 $('body').on('click', '.mobile__filter_group .collection-sidebar__heading', function(e) {
      e.preventDefault();
    if($(this).next().is(':visible')){
      $(this).parent('.mobile__filter_group').removeClass('opened');
      $(this).next().hide();
    }else{
      $(this).parent('.mobile__filter_group').addClass('opened');
      $(this).next().show();
    }    
  });
  /*========== end collection page mobile filter accordion js =====*/

  
$('.menu__link_sel').click(function() {
  var target = $(this).attr('data-target');
  $('.menu_list_other').hide();
  $('#' + target).show();
  $(this).addClass('active_menu').siblings().removeClass('active_menu');
});


  //toggle the component with class accordion_body
  
/* THTR-DEV-APR-365 Display Similar Product on PDP */
  
    if (document.querySelector('.similar-products')) {
    }
    else{
      document.querySelector('.accordion_body').removeAttribute('style');
      document.querySelector('.acc__arrow').classList.remove('arrow_down');
    }
  /* End THTR-DEV-APR-365 Display Similar Product on PDP */
  
    $(document).on("click", ".accordion_head", function(){
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".acc__arrow").removeClass('arrow_down');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".acc__arrow").removeClass('arrow_down');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".acc__arrow").addClass('arrow_down');
        }
    });


  var chipWrapper = document.querySelector(".product-form__chip-wrapper");    
  var chips = chipWrapper.querySelectorAll(".product-form__chip");
  var product__overlay_btn = document.querySelector(".addtocart__btn__overlay");
  const productMoreOneExists = document.querySelector('.product_more_one');
const buyNowbtn = document.querySelector('.template-product-women-shoes .shopify-payment-button');
let attempts = 0;
const maxAttempts = 5; // will check for 30 seconds (50 * 600ms)

const intervalId = setInterval(function () {
  attempts++;
  const now = new Date().toLocaleTimeString();
  const notifyButton = document.getElementById('peppy-notify-me-button-container');
  if (notifyButton) {
    console.log('find');
    notifyButton.style.display = 'none';
    clearInterval(intervalId);
  }

  if (attempts >= maxAttempts) {
    console.log('not found');
    clearInterval(intervalId);
  }
}, 600);
  if (productMoreOneExists) {
      product__overlay_btn.classList.add('selectsize_show'); 
      chips.forEach(function(chip) {
          chip.classList.remove("selected");
      });
      
      chipWrapper.querySelectorAll(".product-form__chip").forEach(function(chip) {
            chip.addEventListener("click", function() {
                /*if (!chip.classList.contains("disabled")) {
                    product__overlay_btn.classList.add("size__selected");
                    buyNowbtn.classList.add('visible_buynow');
                }*/

                if (!chip.classList.contains("disabled")) {
                  
                    product__overlay_btn.classList.add("size__selected");
                    buyNowbtn.classList.add('visible_buynow');
                    const addtocart = document.querySelector('.mb-show.product-form__cart-submit-j');
                    if(addtocart){
                      addtocart.setAttribute('aria-disabled', 'false');
                      addtocart.setAttribute('aria-label', 'Add to cart');
                      addtocart.classList.remove('soldout__button_form');
                      const textSpan = addtocart.querySelector('[data-add-to-cart-text]');
                      
                      addtocart.disabled = false;
                      if (textSpan) {
                        textSpan.textContent = 'Add to cart';
                      }
                    }
                    
                }
                else{
                 
                  const soldout = document.querySelector('.mb-show.product-form__cart-submit-j');
                  if(soldout){
                    product__overlay_btn.classList.remove('selectsize_show');

                    soldout.setAttribute('aria-disabled', 'true');
                    soldout.setAttribute('aria-label', 'Sold out');
                    soldout.classList.add('soldout__button_form');
                    const textSpan = soldout.querySelector('[data-add-to-cart-text]');
                    buyNowbtn.classList.remove('visible_buynow');
                    soldout.disabled = true;
                    if (textSpan) {
                      textSpan.textContent = 'Sold Out';
                    }
                  }
                }
            });
      });
  }
  else{
    product__overlay_btn.classList.add('selectsize_hide'); 
  }
  


    
    var section3 = document.querySelector(".product-form__controls-group--options");

    product__overlay_btn.addEventListener("click", function() {
        section3.scrollIntoView({ behavior: "smooth",block: 'center' });
    });



  
});



// $(window).ready(function(){
//     function initFixedButton() {

//       var target_shown = document.querySelector(".product__meta-inner");
//       var addtocart_btn = document.querySelector(".product-form__controls-group--submit");
//       var originalOffsetTop = target_shown.getBoundingClientRect().top - window.scrollY;
//       console.log(originalOffsetTop)
//       function toggleFixedClass() {
//           if (window.scrollY >= 200) {
//               addtocart_btn.classList.add("sticky_btn");
//           } else {
//               addtocart_btn.classList.remove("sticky_btn");
//           }
//       }
//       toggleFixedClass();
//       window.addEventListener("scroll", toggleFixedClass);
      
//     }
//      initFixedButton();
// });


// $(window).ready(function(){
//     function initFixedButton() {

//       var btn = document.querySelector(".product-form__controls-group--submit");
//     var originalOffsetTop = btn.getBoundingClientRect().top + window.scrollY - 43;
//     console.log(originalOffsetTop)
//     function toggleFixedClass() {
//         if (window.scrollY >= originalOffsetTop) {
//             btn.classList.add("sticky_btn");
//         } else {
//             btn.classList.remove("sticky_btn");
//         }
//     }
//     toggleFixedClass();
//     window.addEventListener("scroll", toggleFixedClass);
      
//     }
//  setTimeout(initFixedButton, 1500);
// });
